module.exports = __webpack_public_path__ + "static/media/11.e5215d19.jpg";